import { useEffect, useState } from "react";

export const useWordCount = (content: string) => {
  const [wordCount, setWordCount] = useState(0);

  useEffect(() => {
    const words = content.trim().split(/\s+/).filter(word => word.length > 0);
    setWordCount(words.length);
  }, [content]);

  return wordCount;
};